module.exports = __webpack_public_path__ + "img/bondi-beach-radio.b1d50ea9.png";